// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"ac0b6e07","453":"7b1f2b01"}[chunkId] + ".chunk.js";
};